import { CollecStatusType, Payment, PayMethodType } from '../payment/payment'
import type { SaleItem } from '../sale-item/sale-item'

interface GiftCardVisibilityOptions {
  showGiftCard: boolean
  shouldCreateStoredPayMethod: boolean
  isStoredPayMethodCreationSideEffectOfPayment: boolean
  allowGiftCardBeforeStoredPayMethod?: boolean
  hasInFlightPspPayment?: boolean
}

interface GiftCardStoredPayMethodSetupOptions {
  allowGiftCardBeforeStoredPayMethod?: boolean
  shouldCreateStoredPayMethod: boolean
  isStoredPayMethodCreationSideEffectOfPayment: boolean
}

export function shouldShowGiftCardSection({
  showGiftCard,
  shouldCreateStoredPayMethod,
  isStoredPayMethodCreationSideEffectOfPayment,
  allowGiftCardBeforeStoredPayMethod,
  hasInFlightPspPayment
}: GiftCardVisibilityOptions): boolean {
  return (
    showGiftCard &&
    !hasInFlightPspPayment &&
    (!shouldCreateStoredPayMethod ||
      (allowGiftCardBeforeStoredPayMethod === true &&
        isStoredPayMethodCreationSideEffectOfPayment))
  )
}

// the psp fixes the amount when the hosted session is created, so applying a gift
// card now would be discounted on the sale but still charged in full at the psp
export function hasInFlightPspPayment(payments: Payment[]): boolean {
  return (
    payments?.some(
      (payment) =>
        payment.collectStatus === CollecStatusType.COLLECT_STATUS_COLLECTABLE &&
        payment.payMethod !== PayMethodType.PAY_METHOD_DIRECT_DEBIT &&
        payment.paymentProviderType != null &&
        payment.externalPaymentId != null
    ) ?? false
  )
}

export function shouldRequireStoredPayMethodSetup({
  allowGiftCardBeforeStoredPayMethod,
  shouldCreateStoredPayMethod,
  isStoredPayMethodCreationSideEffectOfPayment
}: GiftCardStoredPayMethodSetupOptions): boolean {
  return (
    allowGiftCardBeforeStoredPayMethod === true &&
    shouldCreateStoredPayMethod &&
    isStoredPayMethodCreationSideEffectOfPayment
  )
}

export function excludeGiftCardAdjustments(saleItems: SaleItem[]): SaleItem[] {
  return saleItems.filter((saleItem) => !saleItem.giftCardUseId)
}
